import logo from './logo.svg';
import './App.css';
import Home from './Components/Home';
import Login from './Components/Login';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import UserDashboard from './Components/Userdashboard';
import ViewUsers from './Components/ViewUsers';
import Profile from './Components/Profile';
import Community from './Components/Community';
import UserFullProfile from './Components/UserFullProfile';
import AdminDashboard from './AdminComponents/AdminDashboard';
import AdminProfile from './AdminComponents/AdminProfile';
import ManageUsers from './AdminComponents/ManageUsers';
import Interest from './Components/Interest';
import AdViewUsers from './AdminComponents/AdViewUsers';


 export const baseUrl = 'https://lingayatwelfarekarnataka.com/api'


//export const baseUrl = 'http://localhost:8000'

function App() {
  return (
    <div className="App">
      <BrowserRouter >
        <ToastContainer />
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />

          <Route path="/userdashboard" element={<UserDashboard />}>

            {/* ✅ Default Page */}
            <Route index element={<Profile />} />

            <Route path="view-users" element={<ViewUsers />} />
            <Route path="profile" element={<Profile />} />
            <Route path="view-profile/:id" element={<UserFullProfile />} />
            <Route path="community" element={<Community />} />
             <Route path="interest" element={<Interest />} />

          </Route>


          <Route path="/admindashboard" element={<AdminDashboard />}>

            {/* ✅ Default Page */}
            <Route index element={<ManageUsers />} />

            <Route path="manage-users" element={<ManageUsers />} />
             <Route path="AdViewUsers" element={<AdViewUsers />} />
            <Route path="adminProfile" element={<AdminProfile />} />
             <Route path="community" element={<Community />} />
           
           

          </Route>






        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
